module.exports = __webpack_public_path__ + "resources/img/img_datahunt3.b618c2735cc57f47d3870483678172f8.png";